import { memdbRequest } from "./index.js";
export var Sex;
(function (Sex) {
    // BothSex = -1,
    Sex[Sex["Male"] = 0] = "Male";
    Sex[Sex["Female"] = 1] = "Female";
    Sex[Sex["Unknown"] = 2] = "Unknown";
})(Sex || (Sex = {}));
export function getMember(id, schema, headers) {
    return memdbRequest.get(`/member/${id}`, {
        params: { schema },
        headers,
    });
}
export function getMembers(params) {
    const id = params.id;
    if (Array.isArray(id)) {
        return memdbRequest.get("/member", {
            params: {
                ...params,
                id: id.toString(),
            },
        });
    }
    return memdbRequest.get("/member", { params });
}
export function getFidePlayer({ fideId, ...params }) {
    return memdbRequest.get(`/fideplayer/${fideId}`, { params });
}
export function createMember({ clubid, password, ignoreDupe, ...member }) {
    return memdbRequest.post("/member", {
        body: {
            member,
            clubid,
            ignoreDupe,
            ...(password && {
                password,
                password2: password,
            }),
        },
    });
}
export const updateMember = (member) => {
    return memdbRequest.post(`/member/${member.id}`, { body: { member } });
};
export const setMemberPassword = ({ id, password, token, }) => memdbRequest.post(`/member/${id}`, {
    ...(token && {
        headers: {
            token,
        },
    }),
    body: {
        password,
        password2: password,
    },
});
export const login = async ({ email, password, origin, }) => {
    const [value, loginAs] = email.split(":");
    return memdbRequest.post("/login", {
        ...(origin && { headers: { origin } }),
        body: {
            [Number.isNaN(+value) ? "email" : "id"]: Number.isNaN(+value)
                ? value
                : +value,
            password,
            loginAs,
        },
    });
};
export const recoverPassword = async (params) => memdbRequest.get("member/recoverpassword", { params });
//# sourceMappingURL=member.js.map